<template>
  <div class="ShopSetwrap" v-if="shop">
    <!-- 头部 -->
    <!-- <div class="bg_black text_white">
      <div class="ninew bodybox"> -->
    <van-nav-bar
      :title="$t('ShopSet.title')"
      left-arrow
      fixed
      @click-left="$router.push('/ShopList')"
    >
      <!-- <van-icon
        name="./static/img/Trash.png"
        slot="right"
        @click="delShop()"
        style="font-size: 24px"
      /> -->
    </van-nav-bar>

    <div class="list_wrap bodybox ninew">
      <div class="setwrap">
        <div class="bottom-left">
          <div :class="[shop.active == 0 ? 'shopType' : 'actType']">
            <!-- {{shop.active==0?'未上线':'已上线'}} -->
            <span v-if="shop.active == 0">{{ $t("ShopSet.inActive") }}</span>
            <span v-else>{{ $t("ShopSet.active") }}</span>
          </div>
          <div class="shopLeftTime">
            {{ $t("ShopSet.canUse") }}:{{ shop.days }}{{ $t("ShopSet.day") }}
          </div>
        </div>
        <div class="bottom-right">
          <van-button
            class="issueBtn"
            round
            type="default"
            style="font-weight: bold; font-size: 16px"
            @click="isShopShow = true"
            >{{ $t("ShopSet.publishsShop") }}</van-button
          >
          <van-icon
            name="question-o"
            color="#fd3f3f"
            @click="isTipShow = true"
            class="question"
            size="25px"
          />
        </div>
      </div>

      <!-- 管理九宫格 -->
      <div class="partwrap">
        <div class="title">{{ $t("ShopSet.manage") }}</div>
        <div class="partcont">
          <div
            class="content_wrap custor"
            @click="$router.push('/EditShop/' + 'shop')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-01 text-blue fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.editShop") }}</div>
            </div>
          </div>
          <div
            class="content_wrap custor"
            @click="$router.push('/ItemInfoList')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-10 text-blue fs-80"></div>
              <div class="text-20 margintop">{{ $t("platform.itemInfo") }}</div>
            </div>
          </div>
          <div class="content_wrap custor" @click="$router.push('/SetMenu')">
            <div class="content_cont">
              <div class="iconfont icon-icon-02 text-blue fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.setMenu") }}</div>
            </div>
          </div>
          <div
            v-if="isServer"
            class="content_wrap custor"
            @click="$router.push('/SetMenu')"
            style="border-bottom: 1px solid #eee"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-03 text-blue fs-80"></div>
              <div class="text-20 margintop">设定服务内容</div>
            </div>
          </div>
          <div
            v-if="isServer"
            class="content_wrap custor"
            @click="$router.push('/SetMenu')"
            style="border-bottom: 1px solid #eee"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-03 text-blue fs-80"></div>
              <div class="text-20 margintop">设定预约时段</div>
            </div>
          </div>
          <div class="content_wrap custor" @click="$router.push('/SetSeat')">
            <div class="content_cont">
              <div class="iconfont icon-icon-03 text-blue fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.setSeat") }}</div>
            </div>
          </div>
          <div class="content_wrap custor" @click="$router.push('/StaffList')">
            <div class="content_cont">
              <div class="iconfont icon-icon-04 text-blue fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.staffList") }}</div>
            </div>
          </div>
          <div class="content_wrap custor" @click="$router.push('/ShopStatus')">
            <div class="content_cont">
              <div class="iconfont icon-icon-05 text-blue fs-80"></div>
              <div class="text-20 margintop">
                {{ $t("ShopSet.shopStatus") }}
              </div>
            </div>
          </div>
          <div class="content_wrap custor" @click="$router.push('/payList')">
            <div class="content_cont">
              <div class="iconfont icon-icon-06 text-blue fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.payEdit") }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 设定九宫格 -->
      <div class="partwrap">
        <div class="title">{{ $t("ShopSet.set") }}</div>
        <div class="partcont">
          <div
            class="content_wrap custor"
            @click="$router.push('/EditBook')"
            style="border-top: none;border-bottom: 1px solid #eee"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-14 text-black fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.editBook") }}</div>
            </div>
          </div>
          <div
            class="content_wrap custor"
            @click="$router.push('/UnitList')"
            style="border-bottom: 1px solid #eee"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-09 text-black fs-80"></div>
              <div class="text-20 margintop">
                {{ $t("itemInfo.unitTitle") }}
              </div>
            </div>
          </div>
          <div
            class="content_wrap custor"
            style="border-bottom: 1px solid #eee"
            @click="$router.push('/PhoneList')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-11 text-black fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.phoneList") }}</div>
            </div>
          </div>

          <div
            class="content_wrap custor"
            @click="$router.push('/CookInfo')"
            style="border-top: none"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-121 text-black fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.cookInfo") }}</div>
            </div>
          </div>
          <div
            class="content_wrap custor"
            @click="$router.push('/PrinterList')"
            style="border-top: none"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-13 text-black fs-80"></div>
              <div class="text-20 margintop">
                {{ $t("ShopSet.printerSet") }}
              </div>
            </div>
          </div>

          <div
            class="content_wrap custor"
            @click="$router.push('/PrintList')"
            style="border-top: none"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-14 text-black fs-80"></div>
              <div class="text-20 margintop">{{ $t("print.name") }}</div>
            </div>
          </div>
          <div
            class="content_wrap custor"
            style="border-bottom: 1px solid #eee"
            @click="$router.push('/EditTable')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-13 text-black fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.editTable") }}</div>
            </div>
          </div>
          <div
            class="content_wrap custor"
            @click="$router.push('/paySet')"
            style="border-bottom: 1px solid #eee"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-07 text-black fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.paySet") }}</div>
            </div>
          </div>

          <div
            class="content_wrap custor"
            style="border-bottom: 1px solid #eee"
            @click="$router.push('/AddressList')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-08 text-black fs-80"></div>
              <div class="text-20 margintop">{{ $t("platform.address") }}</div>
            </div>
          </div>

          <div
            class="content_wrap custor"
            style="border-right: 1px solid #eee"
            @click="$router.push('/ReceiptInfoSet')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-07 text-black fs-80"></div>
              <div class="text-20 margintop">
                {{ $t("platform.receiptSet") }}
              </div>
            </div>
          </div>
          <div
            class="content_wrap custor"
            style="border-right: 1px solid #eee"
            @click="$router.push('/EditShop/' + 'settings')"
          >
            <div class="content_cont">
              <div
                class="iconfont icon-icon-01 text-blue fs-80"
                style="color:#000000"
              ></div>
              <div class="text-20 margintop">{{ $t("ShopList.setting") }}</div>
            </div>
          </div>
          <!-- <div class="content_wrap custor" @click="$router.push('/invoice')">
            <div class="content_cont">
              <div
                class="iconfont icon-icon-01 text-blue fs-80"
                style="color:#000000"
              ></div>
              <div class="text-20 margintop">发票资料</div>
            </div>
          </div> -->
          <!-- <div
            class="content_wrap custor"
            style="border-right: 1px solid #eee"
            @click="$router.push('/RechargeAmountSetting')"
          >
            <div class="content_cont">
              <div
                class="iconfont icon-icon-01 text-blue fs-80"
                style="color:#000000"
              ></div>
              <div class="text-20 margintop">
                {{ $t("ShopList.RechargeAmountSetting") }}
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- 报表九宫格 -->
      <div class="partwrap">
        <div class="title">{{ $t("ShopSet.report") }}</div>
        <div class="partcont">
          <div
            class="content_wrap custor"
            @click="$router.push('/MonthReport')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-15 text-red fs-80"></div>
              <div class="text-20 margintop">
                {{ $t("ShopSet.monthReport") }}
              </div>
            </div>
          </div>

          <div
            class="content_wrap custor"
            @click="$router.push('/WeekReport')"
            style="border-bottom: 1px solid #eee"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-16 text-red fs-80"></div>
              <div class="text-20 margintop">
                {{ $t("ShopSet.weekReport") }}
              </div>
            </div>
          </div>

          <div class="content_wrap custor" @click="$router.push('/DayReport')">
            <div class="content_cont">
              <div class="iconfont icon-icon-17 text-red fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.dayReport") }}</div>
            </div>
          </div>

          <div
            class="content_wrap custor"
            @click="$router.push('/YearsStockdetail')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-18 text-red fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.stockList") }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 统计九宫格 -->
      <div class="partwrap">
        <div class="title">{{ $t("ShopSet.statistical") }}</div>
        <div class="partcont">
          <div
            class="content_wrap custor"
            @click="$router.push('/CustomerTime')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-19 text-orange fs-80"></div>
              <div class="text-20 margintop">
                {{ $t("ShopSet.customerTime") }}
              </div>
            </div>
          </div>

          <div class="content_wrap custor" @click="$router.push('/MenuRank')">
            <div class="content_cont">
              <div class="iconfont icon-icon-20 text-orange fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.menuRank") }}</div>
            </div>
          </div>

          <div class="content_wrap custor" @click="$router.push('/TableRank')">
            <div class="content_cont">
              <div class="iconfont icon-icon-21 text-orange fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.tableRank") }}</div>
            </div>
          </div>

          <div
            class="content_wrap custor"
            @click="$router.push('/StaffReport')"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-22 text-orange fs-80"></div>
              <div class="text-20 margintop">
                {{ $t("ShopSet.staffReport") }}
              </div>
            </div>
          </div>

          <div
            class="content_wrap custor"
            @click="$router.push('/CookTime')"
            style="border-bottom: none"
          >
            <div class="content_cont">
              <div class="iconfont icon-icon-23 text-orange fs-80"></div>
              <div class="text-20 margintop">{{ $t("ShopSet.cookTime") }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- <van-cell-group class="list">
        <van-cell
          icon="./static/img/set_shop.png"
          :title="$t('ShopSet.editShop')"
          is-link
          to="/EditShop"
        />
        <van-cell
          icon="./static/img/set_Menu.png"
          :title="$t('ShopSet.setMenu')"
          is-link
          to="/SetMenu"
        />
        <template v-if="isServer">
          <van-cell
            icon="./static/img/set_Menu.png"
            title="2.设定服务内容"
            is-link
            to="/SetMenu"
          />
          <van-cell
            icon="./static/img/set_Menu.png"
            title="3.设定预约时段"
            is-link
            to="/SetMenu"
          />
        </template>

        <van-cell
          icon="./static/img/set_table.png"
          :title="$t('ShopSet.setSeat')"
          is-link
          to="/SetSeat"
        />
        <van-cell
          icon="./static/img/set_staff.png"
          :title="$t('ShopSet.staffList')"
          is-link
          to="/StaffList"
        />
        <van-cell
          icon="./static/img/dianpuzhuangtai.png"
          :title="$t('ShopSet.shopStatus')"
          is-link
          to="/ShopStatus"
        />
        <van-cell
          icon="./static/img/payEdit.png"
          :title="'6.' + $t('ShopSet.payEdit')"
          is-link
          to="/payList"
        />
        <van-cell
          icon="./static/img/payEdit.png"
          :title="'7.' + $t('ShopSet.paySet')"
          is-link
          to="/paySet"
        />
        <van-cell
          icon="./static/img/payEdit.png"
          :title="'8.' + $t('platform.address')"
          is-link
          to="/AddressList"
        />

        <div class="divideLine"></div>
        <van-cell
          icon="./static/img/payEdit.png"
          :title="$t('platform.itemInfo')"
          is-link
          to="/ItemInfoList"
        />
        <van-cell
          icon="./static/img/payEdit.png"
          :title="$t('itemInfo.unitTitle')"
          is-link
          to="/UnitList"
        />
    -->
      <!-- <van-cell icon="./static/img/payEdit.png" :title="'10.'+$t('platform.warehousing')" is-link to="/WarehousingList" />
			 -->
      <!-- <div class="divideLine"></div>
        <van-cell
          icon="./static/img/dianhualiebiao.png"
          :title="$t('ShopSet.phoneList')"
          is-link
          to="/PhoneList"
        /> -->
      <!--客户列表-->
      <!-- <div class="divideLine"></div>
        <van-cell
          icon="./static/img/houchuxinxi.png"
          :title="$t('ShopSet.cookInfo')"
          is-link
          to="/CookInfo"
        />
        <van-cell
          icon="./static/img/printer.png"
          :title="$t('ShopSet.printerSet')"
          is-link
          to="/PrinterList"
        />
        <van-cell
          icon="./static/img/printer.png"
          :title="$t('print.name')"
          is-link
          to="/PrintList"
        /> -->

      <!-- <van-cell icon="./static/img/Financial.png" title="财务报表" is-link to="/NoData"/>
			<van-cell icon="./static/img/Sales.png" title="销售报表" is-link to="/NoData"/>
			<van-cell icon="./static/img/staff.png" title="员工报表" is-link to="/NoData"/> -->
      <!-- <div class="divideLine"></div>
        <van-cell
          icon="./static/img/paiduisheding.png"
          :title="$t('ShopSet.editTable')"
          is-link
          to="/EditTable"
        />
        <van-cell
          icon="./static/img/yuyuesheding.png"
          :title="$t('ShopSet.editBook')"
          is-link
          to="/EditBook"
        />
        <div class="divideLine"></div>
        <van-cell
          icon="./static/img/baobiao_M.png"
          :title="$t('ShopSet.monthReport')"
          is-link
          to="/MonthReport"
        />
        <van-cell
          icon="./static/img/baobiao_week.png"
          :title="$t('ShopSet.weekReport')"
          is-link
          to="/WeekReport"
        />
        <van-cell
          icon="./static/img/baobiao_day.png"
          :title="$t('ShopSet.dayReport')"
          is-link
          to="/DayReport"
        />
        <van-cell
          icon="./static/img/baobiao_day.png"
          :title="$t('ShopSet.stockList')"
          is-link
          to="/YearsStockdetail"
        />

        <div class="divideLine"></div>
        <van-cell
          icon="./static/img/keliangbaogao.png"
          :title="$t('ShopSet.customerTime')"
          is-link
          to="/CustomerTime"
        />
        <van-cell
          icon="./static/img/Menu_rank.png"
          :title="$t('ShopSet.menuRank')"
          is-link
          to="/MenuRank"
        />
        <van-cell
          icon="./static/img/zhuowei_rank.png"
          :title="$t('ShopSet.tableRank')"
          is-link
          to="/TableRank"
        />
        <van-cell
          icon="./static/img/yuangongbaobiao.png"
          :title="$t('ShopSet.staffReport')"
          is-link
          to="/StaffReport"
        />
        <van-cell
          icon="./static/img/cook_speed.png"
          :title="$t('ShopSet.cookTime')"
          is-link
          to="/CookTime"
        />
        <div class="divideLine"></div>
        <div style="height: 60px; width: 100%; background-color: #f3f5f7"></div>
      </van-cell-group> -->
      <!-- <div class="setting">店功能设定完成，须发布才能生效</div> -->
      <van-dialog v-model="isShopShow" :style="{ height: '70%' }">
        <van-cell-group>
          <van-cell>
            <template slot="title">
              <div style="color: #222; text-align: center; font-size: 18px">
                {{ $t("ShopSet.publishsShop") }}
              </div>
            </template>
          </van-cell>
          <van-cell
            :title="$t('ShopSet.servicePoint')"
            :value="sessionStorage.coins + $t('ShopSet.count')"
          />
        </van-cell-group>
        <div class="cardGroup">
          <van-grid :border="true" :column-num="2" gutter="30px" square>
            <template v-for="(item, index) in periods">
              <van-grid-item
                :key="index"
                :class="[actCardIndex == index ? 'actItem' : '']"
                @click="changeActIndex(index)"
              >
                <div>{{ item.days }}{{ $t("ShopSet.day") }}</div>
                <div>{{ item.days }}{{ $t("ShopSet.count") }}</div>
                <!-- <div style="color: red">{{ getDiscount(item.discount) }}</div> -->
              </van-grid-item>
            </template>
          </van-grid>
        </div>
        <van-tabbar>
          <van-button
            style="
              height: 35px;
              margin: 10px 3%;
              line-height: 35px;
              width: 94%;
              background: #e5e5e5;
              color: #222;
            "
            round
            @click="isShopShow = false"
            >{{ $t("ShopSet.cancel") }}</van-button
          >
          <van-button
            style="
              height: 35px;
              margin: 10px 3%;
              line-height: 35px;
              width: 94%;
              background: #2f75f4;
              color: #fff;
            "
            round
            @click="activeShop()"
            >{{ $t("ShopSet.certain") }}</van-button
          >
        </van-tabbar>
      </van-dialog>
      <van-popup
        v-model="isTipShow"
        position="bottom"
        :style="{ height: '75%' }"
      >
        <van-cell value-class="tc" :value="$t('ShopSet.note')">
          <van-icon
            slot="icon"
            name="./static/img/dele_Seat.png"
            size="25px"
            @click="isTipShow = false"
          />
        </van-cell>
        <ul>
          <li>
            <p>{{ $t("ShopSet.p1") }}</p>
          </li>
          <li>
            <p>{{ $t("ShopSet.p2") }}</p>
          </li>
          <li>
            <p>{{ $t("ShopSet.p3") }}</p>
          </li>
          <li>
            <p>{{ $t("ShopSet.p4") }}</p>
          </li>
        </ul>
      </van-popup>
    </div>
    <!-- <div style="height: 50px"></div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      shop: {},
      periods: [],
      isShopShow: false,
      isTipShow: false,
      time: 30,
      actId: "",
      maxTime: 0,
      actCardIndex: 0,
      isServer: false,
      getLangs: ""
    };
  },
  mounted: function() {
    sessionStorage.setItem("actShopId", this.$route.params.id);
    this.getShop();
    this.getPeriod();
    console.log(this.$i18n.locale);
    this.getLangs = this.$i18n.locale;
  },
  methods: {
    // 获取激活周期列表
    getPeriod() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/period/index"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.periods = res.data.data;
            this.actId = res.data.data[0].id;
            this.time = res.data.data[0].days;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {});
    },
    // 获取店铺信息
    getShop() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + this.$route.params.id + "/show"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shop = res.data.data;
            sessionStorage.setItem("activeStore", res.data.data.active);
            sessionStorage.setItem("currency", res.data.data.currency.unit);
            sessionStorage.setItem("is_quick", res.data.data.is_quick);
            if (res.data.data.colorvalue) {
              sessionStorage.setItem("colorCode", res.data.data.colorvalue);
            } else {
              sessionStorage.setItem("colorCode", res.data.data.color.code);
            }
            sessionStorage.setItem("shopInfos", JSON.stringify(this.shopInfos));
            console.log(this.shop.language.name_en);
            if (this.shop.language.name_en == "zh_cn") {
              this.$i18n.locale = "zh";
            } else if (this.shop.language.name_en == "zh_hk") {
              this.$i18n.locale = "hk";
            } else {
              this.$i18n.locale = "en";
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopSet.message")
          });
        });
    },

    // 上线店铺
    activeShop() {
      if (sessionStorage.coins >= this.time) {
        this.$dialog
          .confirm({
            title: this.$t("ShopSet.shopOnLine"),
            message:
              this.$t("ShopSet.text") +
              this.time +
              this.$t("ShopSet.severceCount"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "PATCH",
              headers: {
                Authorization: "Bearer " + sessionStorage.token
              },
              url:
                this.$build + "/api/store/" + this.$route.params.id + "/active",
              data: {
                id: this.actId
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.isShopShow = false;
                  this.getShop();
                  var coins = sessionStorage.coins - this.time;
                  this.time = this.periods[this.actCardIndex].days;
                  sessionStorage.setItem("coins", coins);
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("ShopSet.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("ShopSet.InsufficientServicePoints")
        });
      }
    },
    // 修改选择周期
    changeActIndex(index) {
      this.actCardIndex = index;
      this.time = this.periods[index].days;
      this.actId = this.periods[index].id;
    },

    getDiscount(num) {
      if (this.getLangs == "en") {
        if (num == "100%") {
          return "";
        } else if (num == "88%") {
          return "12%off";
        } else if (num == "83%") {
          return "17%off";
        } else if (num == "78%") {
          return "22%off";
        }
      } else {
        if (num == "100%") {
          return "";
        } else if (num == "88%") {
          return "88折";
        } else if (num == "83%") {
          return "83折";
        } else if (num == "78%") {
          return "78折";
        }
      }
    }
  }
};
</script>
<style scoped>
@media screen and (min-width: 761px) {
  .fs-80 {
    font-size: 80px;
  }
  .text-20 {
    font-size: 20px;
  }
  .content_cont {
    top: 26% !important;
  }
}

@media only screen and (min-width: 661px) and (max-width: 760px) {
  .fs-80 {
    font-size: 76px;
  }
  .text-20 {
    font-size: 20px;
  }
  .content_cont {
    top: 24% !important;
  }
}

@media only screen and (min-width: 561px) and (max-width: 660px) {
  .fs-80 {
    font-size: 68px;
  }
  .text-20 {
    font-size: 18px;
  }
  .content_cont {
    top: 22% !important;
  }
}

@media only screen and (min-width: 461px) and (max-width: 560px) {
  .fs-80 {
    font-size: 64px;
  }
  .text-20 {
    font-size: 16px;
  }
  .content_cont {
    top: 20% !important;
  }
}

@media only screen and (min-width: 421px) and (max-width: 460px) {
  .fs-80 {
    font-size: 60px;
  }
  .text-20 {
    font-size: 16px;
  }
  .content_cont {
    top: 16% !important;
  }
}

/* 小於420px */
@media only screen and (max-width: 420px) {
  .fs-80 {
    font-size: 50px;
  }
  .text-20 {
    font-size: 16px;
  }
  .content_cont {
    top: 20% !important;
  }
}

.partwrap {
  font-size: 16px;
  /* margin-bottom: 20px; */
  background: white;
  padding: 10px 0px;
  margin-bottom: 10px;
}
.title {
  /* text-align: center; */
  font-size: 22px;
  font-weight: 500;
  padding: 5px 0 5px 15px;
  border-bottom: 1px solid #eee;
}
.partcont {
  height: 100%;
  background: white;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  /* padding-bottom: 10px; */
  /* border-bottom: 1px solid #eee; */
  /* margin-bottom: 20px; */
}
.content_wrap:nth-child(2) {
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}
.content_wrap:nth-child(3) {
  border-bottom: 1px solid #eee;
}
.content_wrap:nth-child(4) {
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
}
.content_wrap:nth-child(5) {
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.content_wrap:nth-child(6) {
  border-bottom: 1px solid #eee;
}
.content_wrap:nth-child(7) {
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
}
.content_wrap:nth-child(8) {
  border-right: 1px solid #eee;
}

.content_wrap {
  width: calc((100% - 3px) / 3);
  text-align: center;
  height: 100%;
  position: relative;
  background: white;
  padding-top: calc((100% - 3px) / 3);
}
.content_cont {
  position: absolute;
  top: 28%;
  /* left: 24%; */
  /* z-index: 0; */
  width: 100%;
}
.margintop {
  margin-top: 10px;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field .van-icon {
  font-size: 20px;
}
/deep/ .van-cell__left-icon,
.van-cell__right-icon {
  font-size: 24px;
}
/deep/ .van-dialog__confirm {
  display: none;
}
/deep/ .van-image {
  font-size: 24px;
  vertical-align: top;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
.list_wrap {
  padding-top: 5px;
  padding-bottom: 10px;
  background-color: #eee;
}

.ShopSetwrap {
  position: relative;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  /* overflow-y: auto; */
  background-color: #f3f3f3;
}
.setting {
  text-align: center;
  color: #b8b8b8;
  margin-top: 30px;
}
.notice {
  word-break: break-all;
  padding: 0 10px;
  text-align: center;
  color: #000;
}
.setwrap {
  width: 100%;
  height: 60px;
  background: #fff;
  margin-bottom: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
  background: #000;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
.issueBtn {
  background: #2f75f4;
  height: 26px;
  line-height: 26px;
  color: #fff;
  border: none;
  outline: none;
}
.cardGroup {
  width: 96%;
  margin-left: 2%;
  margin-top: 30px;
}
.bottom-left {
  display: flex;
  flex-flow: column;
  padding: 0 10px;
  color: #fff;
}
.bottom-right {
  padding: 0 5px;
  display: flex;
}
.question {
  margin: 0 5px;
}
/deep/ .van-grid-item__content {
  border: 2px solid #ccc;
  border-radius: 10px;
}
/deep/ .actItem .van-grid-item__content {
  border: 2px solid #2f75f7;
  border-radius: 10px;
}
.shopType {
  width: 60px;
  color: #fff;
  font-weight: bold;
}
.actType {
  width: 60px;
  color: #fd3f3f;
  font-weight: bold;
}
/*分割线*/
.divideLine {
  height: 20px;
  background: #f3f5f7;
}
ul {
  list-style: decimal;
  /*padding-inline-start: 40px;*/
  padding: 0 10px 0 28px;
}
.tc {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/Shop/ShopSet.vue